import LsqPlayer from '../components/LsqPlayer'
import SendResults from '../components/SendResults'
import { pad } from '../../maths'
import config from '../../../config'

export default {
    delimiters: config.VUE_DELIMITERS,
    components: {
        LsqPlayer,
        SendResults,
    },
    data: {
        rawResults: [],
    },
    filters: {
        pad(x) {
            return pad(x)
        }
    },
    beforeMount() {
        this.data = JSON.parse(this.$el.dataset.content)
    },
    computed: {
        content() {
            return this.data[this.contentKey]
        },
    },
    methods: {
        fetchData(key) {
            let results = sessionStorage.getItem(key)
            this.rawResults = results ? JSON.parse(results) : []
        }
    },
}
